import React, { useEffect } from 'react';
import Button from '../../components/Button/Button';
import {
  AppRoutes,
  ButtonSize,
  ButtonStyle,
  DefaultPageProps,
  MessageStyle } from '../../utils/props';
import useApi from '../../hooks/use-api';
import Message from '../../components/Message/Message';
import CustomImg from '../../components/CustomImg/CustomImg';
import Spinner from '../../components/Spinner/Spinner';
import { useTranslation } from 'react-i18next';
import { isLogged } from '../../utils/utils';

const DeactivateInvoice: React.FC<DefaultPageProps> = ({ settings }) => {
  const currentURL = window.location.href;
  const params = currentURL.split('=');
  const lastParam = params[params.length - 1];
  const { t } = useTranslation('ns');
  const deactivateInvoiceApi = useApi({
    path: `/user/confirm-invoice-deactivation/${lastParam}`,
    defaultSuccessMessage: t('invoice-online-deactivated'),
    defaultErrorMessage: t('error-problem'),
  });
  useEffect(() => {
    deactivateInvoiceApi.put({});
  }, []);
  return (
    <div className="md:flex block">
      <CustomImg
        large={settings?.app_settings?.authentication_image?.large}
        mobile={settings?.app_settings?.authentication_image?.mobile}
        className="md:w-3/5 md:h-auto min-h-60 h-auto"
        alt="This is the main image"
      />
      <div className="flex flex-col content-center justify-center md:w-2/5 w-full p-10 lg:p-12 xl:p-16">
        <h1 className="mb-2 text-2xl font-bold text-blue-900 ">{t('confirm-online-invoice-deactivation')} </h1>
        {deactivateInvoiceApi.loading && (
          <div className="w-full py-20 flex items-center justify-center">
            <Spinner size="normal" color="dark" />
          </div>
        )}
        {deactivateInvoiceApi.errors && (
          <Message type={MessageStyle.Error} className="mb-6">
            {deactivateInvoiceApi.errors}
          </Message>
        )}
        {deactivateInvoiceApi.successMessage && (
          <Message type={MessageStyle.Success} className="mb-6">
            {deactivateInvoiceApi.successMessage}
          </Message>
        )}
        {!deactivateInvoiceApi.loading && (
            <Button
              size={ButtonSize.LargeFull}
              variant={ButtonStyle.Primary}
              title={t('account-enter')}
              className="mb-6"
              href={AppRoutes.Login}
            >
              {!isLogged() && t('go-to-auth')}
              {isLogged() && t('go-to-platform')}
            </Button>
          )}
      </div>
    </div>
  );
};
export default DeactivateInvoice;